import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

/**
 * Sección de un formulario largo: tarjeta con título (h2) y sus campos debajo.
 * Los campos se acomodan con `Grid` (dos columnas solo en escritorio) dentro de `children`.
 *
 * Con `plana` no dibuja la tarjeta: sirve dentro de una pestaña o una tarjeta que ya existe
 * (evita una tarjeta dentro de otra) y separa las secciones con una línea.
 *
 * @param {object} props
 * @param {React.ReactNode} props.titulo
 * @param {React.ReactNode} [props.descripcion] Una línea que explica la sección.
 * @param {React.ReactNode} [props.acciones] Botón u otro control a la derecha del título.
 * @param {boolean} [props.plana] Sin tarjeta, con una línea que la separa de la anterior.
 */
export const SeccionFormulario = ({
  titulo,
  descripcion,
  acciones,
  plana = false,
  children,
}) => {
  const Contenedor = plana ? Box : Paper;
  const estilo = plana
    ? {
        pt: 3,
        mt: 3,
        borderTop: 1,
        borderColor: "divider",
        "&:first-of-type": { pt: 0, mt: 0, borderTop: 0 },
      }
    : { p: { xs: 2, sm: 3 } };

  const encabezado = (
    <>
      <Typography
        component="h2"
        variant="h6"
        sx={{ fontWeight: 700, color: "primary.main" }}
      >
        {titulo}
      </Typography>
      {descripcion && (
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
          {descripcion}
        </Typography>
      )}
    </>
  );

  return (
    <Contenedor component="section" sx={estilo}>
      {acciones ? (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
        >
          <Box>{encabezado}</Box>
          {acciones}
        </Stack>
      ) : (
        encabezado
      )}
      {children}
    </Contenedor>
  );
};
